<template>
  <div class="search-result-content-list">
    <div class="search-result-content-item"
         v-for="(item, index) in list"
         :key="index"
    >
      <ym-program-item v-if="item.contentType === programContentType"
                       :hide-icon="true"
                       audio-type=""
                       list-type="search"
                       :playing-id="0"
                       :item="item"
                       :index="index"
                       :lazy="false"
                       @click-cover="handleShowPage"
                       @click-content="handleShowPage"
      />
      <ym-lesson-item v-if="item.contentType === lessonContentType"
                      :item="item"
                      :lazy="false"
                      @click="handleShowPage"
      />
    </div>
  </div>
</template>

<script>
  import ProgramItem from '@/pages/AudioProgram/components/ProgramListItem';
  import LessonItem from '@/pages/Course/components/CourseLessonItem';
  import { getProductPath, projectJump } from '@/utils';
  import {
    SEARCH_RESULT_CONTENT_PROGRAM_TYPE,
    SEARCH_RESULT_CONTENT_LESSON_TYPE,
  } from '@/utils/constant';

  export default {
    name: 'SearchResultContentList',
    components: {
      'ym-program-item': ProgramItem,
      'ym-lesson-item': LessonItem,
    },
    data() {
      return {
        programContentType: SEARCH_RESULT_CONTENT_PROGRAM_TYPE,
        lessonContentType: SEARCH_RESULT_CONTENT_LESSON_TYPE,
      };
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    methods: {
      handleShowPage(item) {
        const { productType, id } = item;
        const route = getProductPath(productType, id);
        projectJump(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .search-result-content-list {
    padding: 0 @size-base;
  }
</style>
